(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["volices-journal-slider"] && !Shopify.designMode) return;
  try {
    
const initVolicesJournal = (root = document) => {
  const sections = [];
  if (root.matches && root.matches('[data-volices-journal]')) sections.push(root);
  if (root.querySelectorAll) sections.push(...root.querySelectorAll('[data-volices-journal]'));

  sections.forEach((section) => {
    if (section.dataset.vjReady === 'true') return;

    const track = section.querySelector('[data-vj-track]');
    const previous = section.querySelector('[data-vj-prev]');
    const next = section.querySelector('[data-vj-next]');
    if (!track) return;

    section.dataset.vjReady = 'true';

    let dragging = false;
    let startX = 0;
    let startScroll = 0;
    let moved = 0;

    const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;

    const cardStep = () => {
      const card = track.querySelector('.vjournal__card');
      if (!card) return track.clientWidth;
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 20;
      return card.getBoundingClientRect().width + gap;
    };

    const updateArrows = () => {
      if (!previous || !next) return;
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      previous.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= maxScroll - 4;
    };

    if (previous) {
      previous.addEventListener('click', () => {
        if (!isDesktop()) return;
        track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', () => {
        if (!isDesktop()) return;
        track.scrollBy({ left: cardStep(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();

    const stopDragging = () => {
      if (!dragging) return;
      dragging = false;
      track.classList.remove('is-dragging');
    };

    track.addEventListener('dragstart', (event) => {
      if (isDesktop()) event.preventDefault();
    });

    track.addEventListener('mousedown', (event) => {
      if (!isDesktop() || event.button !== 0) return;

      dragging = true;
      startX = event.clientX;
      startScroll = track.scrollLeft;
      moved = 0;
      track.classList.add('is-dragging');
    });

    document.addEventListener('mousemove', (event) => {
      if (!dragging || !isDesktop()) return;

      const delta = event.clientX - startX;
      moved = Math.max(moved, Math.abs(delta));
      track.scrollLeft = startScroll - delta;

      if (moved > 3) event.preventDefault();
    });

    document.addEventListener('mouseup', stopDragging);
    window.addEventListener('blur', stopDragging);

    track.addEventListener('click', (event) => {
      if (moved > 6) {
        event.preventDefault();
        event.stopPropagation();
      }
      moved = 0;
    }, true);
  });
};

initVolicesJournal();
document.addEventListener('shopify:section:load', (event) => initVolicesJournal(event.target));

  } catch(e) { console.error(e); }
})();
})();
